// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScaleWrapperV2_wrapper__1Dgy0"};